// to be replaced by color groups.
export enum SoffitMaterialColorType {
  MatchSiding = 'match-siding',
  MatchTrim = 'match-trim',
}
